import { Button } from "@components/ui/button";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import FormFieldInput from "../../FormField/FormFieldInput";
import { zodResolver } from "@hookform/resolvers/zod";
import { RequestResetFormValuesType, requestResetFormSchema } from "../schemas";

type RequestResetFormPropsType = { onSubmit: (values: RequestResetFormValuesType) => void };

function RequestResetForm({ onSubmit }: RequestResetFormPropsType) {
  const form = useForm<RequestResetFormValuesType>({
    resolver: zodResolver(requestResetFormSchema),
    defaultValues: {
      email: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="w-full space-y-4 align-center justify-center">
        <FormFieldInput form={form} placeholder="E-mail" label="E-mail" name="email" />
        <Button size="lg" type="submit">
          Wyślij e-maila
        </Button>
      </form>
    </Form>
  );
}

export default RequestResetForm;
